import useBackend from '@/backend';

/* --------------------------------- OPTIONS -------------------------------- */
const route = `/bonus/claims?page=1&pageSize=50`;
const headers: HeadersInit = {
	'Content-Type': 'application/json',
};

/* -------------------------------------------------------------------------- */

const useGetClaimedRewards = () => {
	const { url_V3, getAccessToken } = useBackend();

	const getClaimedRewards = async () => {
		try {
			/* -------------------------------------------------------------------------- */
			const token = await getAccessToken({ v: 3 });
			if (!token) throw new Error('Failed to load');
			headers.Authorization = token;
			/* -------------------------------------------------------------------------- */

			const response = await fetch(`${url_V3}${route}`, {
				method: 'GET',
				headers,
			});
			const data = await response.json();
			if (data.success) {
				// setClaimedRewards(data.data);
				return data.data;
			}
		} catch (error) {}
	};

	return {
		getClaimedRewards,
	};
};

export default useGetClaimedRewards;
